import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import loaderimage from "../../images/giphy.gif";
import axios from "axios";
import ConfirmationModal from "../shared/ConfirmationModal";
import NewconfirmationModal from "../shared/NewconfirmationModal";
import AllFailureModal from "../shared/AllFailureModal";
import "react-toastify/dist/ReactToastify.css"; 

const JobCategory = () => {
  const [categories, setCategories] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]); 
  const [loader, setLoader] = useState(false);
  const [industries, setIndustries] = useState([]);
  const [error, setError] = useState(null); 
  const [searchTerm, setSearchTerm] = useState(""); 
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [categoryToDelete, setCategoryToDelete] = useState(null);
  const [showFailureModal, setShowFailureModal] = useState(false);
  const [failureMessage, setFailureMessage] = useState('');

  const fetchIndustries = async () => {
    try {
      const url = process.env.REACT_APP_API_URL + "industries/get-all-industries"; 
      const response = await axios.get(url);
      setIndustries(response?.data); 
    } catch (error) {
      console.error('Error fetching industries:', error);
    }
  };


  const fetchCategory = async () => {
    try {
      setLoader(true);
      setError(null);
      const url = process.env.REACT_APP_API_URL + "category/getcategory";
      const response = await axios.get(url);
      setCategories(response?.data);
      setFilteredCategories(response?.data);
    } catch (error) {
      console.log(error);
      setError(error.message || "Failed to fetch category list."); 
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchCategory();
    fetchIndustries();
  }, []);

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      if (searchTerm === "") {
        setFilteredCategories(categories);
      } else {
        const filtered = categories.filter(category =>
          {
            const categoryName = category?.category_name?.toLowerCase() || "";
            const industryName = getIndustryNameById(category?.industry_id)?.toLowerCase() || "";
            return categoryName.includes(searchTerm) || industryName.includes(searchTerm);
          });

        setFilteredCategories(filtered);
      }
    }, 300);
    return () => clearTimeout(debounceTimeout);
  }, [searchTerm, categories]);


  const getIndustryNameById = (industryId) => {
    const industry = industries.find((industry) => industry.id === industryId);
    return industry ? industry.name : 'Unknown'; // Return industry name or 'Unknown' if not found
  };


  const deleteCategory = async () => {
    try {
      const url = process.env.REACT_APP_API_URL + 'category/delete/' + categoryToDelete;
      const response = await axios.delete(url);
      fetchCategory();
      setShowSuccessModal(true); 
    } catch (error) {
      console.error('Error deleting category:', error);
      setFailureMessage("Failed to delete category.");
      setShowFailureModal(true);
    }
  };

  const handleConfirmDelete = (categoryId) => {
    setCategoryToDelete(categoryId); 
    setShowConfirmModal(true); 
  };

  const handleSuccessModalClose = () => {
    setShowSuccessModal(false);
  };  

  const extractClassName = (iconString) => {
    if (!iconString) return ""; 
    const match = iconString.match(/className="([^"]+)"/);
    return match ? match[1] : iconString; 
  };

  return (
    <div className="">
  <div className="d-flex justify-content-between align-items-center mb-4">
    <h2 className="text-black fw-bold">Category Management</h2>
   <div className="d-flex gap-2 align-items-center" style={{ width: "600px" }}>
          <span className="fw-bold text-secondary text-nowrap">
            {filteredCategories.length} results
          </span>
          <input
            type="text"
            className="form-control"
            placeholder="Search by Category or Industry Name"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
          />
      <Link to="/add_category" className="btn bg-info">+ Add New Category</Link>
    </div>
  </div>

  <div className="card shadow-sm border-0 rounded">
    <div className="card-header bg-info border-bottom py-3">
      <h5 className="mb-0 text-white">Category List</h5>
    </div>
    <div className="card-body p-0">
      <div className="table-responsive" style={{ maxHeight: "500px", overflowY: "auto" }}>
        <table className="table table-hover align-middle mb-0">
          <thead className="bg-light">
            <tr>
              <th>#</th>
              <th>Category ID</th>
              <th>Category Name</th>
              <th>Industry</th>
              <th>SubCategory Name</th>
              <th>Category Icon</th>
              <th className="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
          {loader ? (
                  <tr>
                    <td colSpan="7" className="text-center py-2">
                      <img src={loaderimage} alt="Loading..." height="40" />
                    </td>
                  </tr>
                ) : error ? (
                  <tr>
                    <td colSpan="7" className="text-center text-danger fw-bold py-3">
                      <div className="alert alert-danger text-center m-3" role="alert">
                        Oops! Something went wrong. Please try again later.
                      </div>
                    </td>
                  </tr>
                ) : filteredCategories.length > 0 ? (

            filteredCategories.map((category, index) => (
              <tr key={index} className="border-bottom">
                <td>{index + 1}</td>
                <td>{category?.category_id}</td>
                <td>{category?.category_name}</td>
                <td>{getIndustryNameById(category?.industry_id)}</td>
                <td>{category?.subcategory_id}</td>
                <td>
                  <div className="category-icon">
                    <i className={extractClassName(category.category_icon)} />
                  </div>
                </td>
                <td className="text-center">
                  <div className="d-flex justify-content-center gap-2">
                    <Link
                      to={`/update_category/${category?.category_id}`}
                      className="btn btn-sm btn-outline-warning"
                    >
                      Edit
                    </Link>
                    <button
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => handleConfirmDelete(category.category_id)}
                    >
                      Delete
                    </button>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" className="text-center text-muted fw-bold">
                <div className="alert alert-secondary text-center m-3" role="alert">
                  No Categories Available
                </div>
              </td>
            </tr>
          )}

          </tbody>
        </table>
      </div>
</div>
</div>

  {/* {loader && (
    <div className="text-center mt-3">
      <img src={loaderimage} alt="Loading..." className="img-fluid" style={{ height: "50px" }} />
    </div>
  )} */}
      {/* Confirmation Modal for Delete */}
      <ConfirmationModal
        show={showConfirmModal}
        onHide={() => setShowConfirmModal(false)}
        modalMessage="Are you sure you want to delete this category?"
        operationType="Confirm"
        confirmation={() => {
          deleteCategory();
          setShowConfirmModal(false); // Close modal after confirmation
        }}
      />

     {/* CHANGE: Success Modal for Deletion using NewconfirmationModal */}
     <NewconfirmationModal
        show={showSuccessModal}
        onHide={handleSuccessModalClose}
        modalMessage="Category deleted successfully!"
        operationType="OK"
        timeoutDuration={3000}
      />

      {/* CHANGE: Failure Modal for Delete Error using AllFailureModal */}
      <AllFailureModal
        show={showFailureModal}
        onHide={() => setShowFailureModal(false)}
        modalMessage={failureMessage}
        operationType="OK"
        timeoutDuration={3000}
      />
    </div>
  );
};

export default JobCategory;